import LocationChart from "../../dsp/components/LocationChart";
import AMCReportTable from "./AMCReportTable";
import { useAMCReportData } from "../hooks/useAMCReportData";
import { Col } from "react-bootstrap";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import getMetricSpec from "../../merchandising/utils/metrics";
import { mapCountryCodeToName, mapStateCodeToName } from "../utils/utils";

const AMCGeoReport = ({ reportData, reportDetails, queryDetails }) => {
  const { t } = useTranslation(["amc"]);
  const [selectedMetric, setSelectedMetric] = useState("total_impressions");

  const { data: dataByState } = useAMCReportData(
    null,
    "DSP_PERFORMANCE_BY_LOCATION_INTERNAL",
    true,
    reportDetails?.id,
    !!reportDetails?.id,
  );

  const metric = useMemo(() => getMetricSpec(selectedMetric), [selectedMetric]);

  const metricOptions = [
    { value: "total_impressions", label: t(($) => $.amc["Impressions"]) },
    { value: "unique_reach", label: t(($) => $.amc["Unique Reach"]) },
    { value: "users_that_clicked", label: t(($) => $.amc["Users that Clicked"]) },
    { value: "dsp_total_detail_page_views", label: t(($) => $.amc["Detail Page Views"]) },
    { value: "dsp_total_add_to_cart", label: t(($) => $.amc["Add to Carts"]) },
    { value: "purchases", label: t(($) => $.amc["Purchases"]) },
    { value: "total_product_sales", label: t(($) => $.amc["Total Product Sales"]) },
  ];

  const tableData = useMemo(() => {
    if (!reportData) {
      return [];
    }
    return reportData.map((d) => {
      return {
        state: mapStateCodeToName(d.iso_state_province_code),
        country: mapCountryCodeToName(d.iso_country_code),
        ...d,
      };
    });
  }, [reportData]);

  const geoData = useMemo(() => {
    if (!dataByState) {
      return [];
    }
    return dataByState
      .filter((d) => {
        return d.iso_country_code === "US" && d.iso_state_province_code.split("-")[1];
      })
      .map((d) => {
        return {
          "hc-key": d.iso_state_province_code.toLowerCase(),
          value: metric.accessor(d),
          d,
        };
      });
  }, [dataByState, metric]);

  const regionData = useMemo(() => {
    if (!dataByState) {
      return [];
    }
    return dataByState.map((d) => {
      const region =
        (mapStateCodeToName(d.iso_state_province_code) || t(($) => $.amc["Other"])) + ", " + d.iso_country_code;
      return {
        ...d,
        region,
      };
    }, {});
  }, [dataByState, t]);

  return (
    <>
      <Col xs={12}>
        <LocationChart
          geoData={geoData}
          selectedMetric={selectedMetric}
          metricOptions={metricOptions}
          onSelectMetric={setSelectedMetric}
          regionData={regionData}
        />
      </Col>
      <Col xs={12}>
        <AMCReportTable reportData={tableData} reportDetails={reportDetails} queryDetails={queryDetails} />
      </Col>
    </>
  );
};

export default AMCGeoReport;
